import { lessonsS1S3 } from './lessonContent1';
import { lessonsS4S6 } from './lessonContent2';
import { lessonsS7S10 } from './lessonContent3';
import { lessonsS11S13 } from './lessonContent4';
import { lessonsS14S16 } from './lessonContent5';

const allItems = [
  ...lessonsS1S3,
  ...lessonsS4S6,
  ...lessonsS7S10,
  ...lessonsS11S13,
  ...lessonsS14S16,
];

export const getAllItems = () => allItems;
export const getItemById = (id) => allItems.find(item => item.id === id);
